import { DateTime, Duration } from 'luxon';

const DATE_TIME_FORMAT = 'hh:mm a dd/LL/yyyy';

const formatDateTime = (date, format = DATE_TIME_FORMAT) => {
    return DateTime.fromISO(date).toFormat(format);
};

const timeAgo = (date) => {
    // TODO: pick, hours, months, years depending on length of time
    const now = DateTime.local();
    const past = DateTime.fromISO(date);

    const diff = now.diff(past, 'hours');
    return `${Math.floor(diff.hours)} hours ago`;
};

const formatDuration = (duration) => {
    return Duration.fromObject({ seconds: duration }).toFormat('hh:mm:ss');
};

export {
    formatDateTime,
    timeAgo,
    formatDuration,
}
